// ES
export const calendarHotel = {
  btn: {
    today: "Hoy",
  },
  summary: {
    availableLabel: "Disponibles",
  },
  tooltip: {
    closed: "Cerrado",
    dragToCreate: "Arrastra para rango (crear reserva)",
  },
  labels: {
    room: "habitación",
    rooms: "habitaciones",
    number: "NÚMERO:",
    capacityIconAlt: "Capacidad",
    maintenanceBadge: "MANT.",
  },
  toasts: {
    reservationCreatedOk: "Reserva creada correctamente.",
    reservationCreateErrPrefix: "No se pudo crear la reserva: ",
    roomChangedOk: "Habitación cambiada correctamente",
    roomChangedErr: "Error al cambiar la habitación",
    roomTypeChangedOk: "La reserva pasa a {type}",
  },
  warn: {
    selectTwoDays: "Selecciona al menos dos días (llegada y salida).",
  },
  errors: {
    closedForBooking: "No puedes reservar en una habitación/cupo cerrado.",
    noAvailabilityTitle: "Sin disponibilidad",
    noAvailabilityDetail: "No hay habitaciones disponibles para ese tipo en esas fechas.",
    noRatesTitle: "Sin tarifas asignadas",
    noRatesDetail: "No hay tarifas disponibles para ese tipo en esas fechas.",
    missingDataTitle: "Faltan datos",
    missingDataDetail: "Completa todos los campos obligatorios.",
  },
  maintenanceModal: {
    titleFallback: "Habitación",
    statusSection: "Estado",
    closeForMaintenance: "Cerrar por mantenimiento",
    open: "Abrir",
    hint:
      "Cuando la habitación está en mantenimiento, no se puede vender y sus celdas aparecerán en rojo. Las reservas existentes se respetan.",
    actions: {
      cancel: "Cancelar",
      save: "Guardar",
      saving: "Guardando…",
    },
  },

  // ===== NUEVO: Modal de reservas =====
  modal: {
    title: "Registrar nueva reserva",
    startDate: "Llegada",
    endDate: "Salida",
    roomType: "Tipo de habitación",
    roomTypePlaceholder: "Selecciona tipo",
    quantity: "Cantidad de habitaciones",
    available: "disponibles",
    guestName: "Nombre del responsable",
    guestNamePlaceholder: "Responsable de la reserva",
    guests: "Número de huéspedes",
    guestsPlaceholder: "Cantidad de huéspedes",
    phone: "Teléfono",
    email: "Correo electrónico",
    notes: "Observación",
    notesPlaceholder: "Notas internas de la reserva (ej. llega tarde, cuna, alergias…)",
    addType: "Añadir otro tipo de habitación",
    price: "Precio",
    pricePlaceholder: "Introduce el precio",
    cancel: "Cancelar",
    create: "Crear reserva",
  },

  // ===== Validaciones =====
  validation: {
    minGuestsTitle: "Número de huéspedes insuficiente",
    minGuestsDetail: "Debe haber al menos {min} huésped(es) para {rooms} habitación(es).",
    maxGuestsTitle: "Límite de huéspedes excedido",
    maxGuestsDetail: "Máximo {maxPerRoom} huéspedes por habitación ({maxTotal} en total para {rooms} habitaciones).",
    maxRoomsTitle: "Límite excedido",
    maxRoomsDetail: "No puedes reservar más de {max} habitaciones.",
  },

  // ===== Promociones e impuestos =====
  promotions: {
    limitTitle: "Límite alcanzado",
    limitDetail: "No puedes agregar más de 1 promoción.",
  },
  taxes: {
    limitTitle: "Límite alcanzado",
    limitDetail: "No puedes agregar más de 1 impuesto.",
  },
};
